import React, { useState, useEffect } from 'react';
import CSPHelper from './CSPHelper';

const generateNonce = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let nonce = '';
    for (let i = 0; i < 24; i++) {
      nonce += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    var gtmScript = document.getElementById("googleScriptId");
    if(gtmScript!==undefined && gtmScript !==null){
      gtmScript.setAttribute("nonce",nonce);
    }
    return nonce;
  };

function NonceHelper() {

  const [nonce, setNonce] = useState('');
  

  useEffect(() => {
    setNonce(generateNonce());
  }, []);

  return (
    <>
    <CSPHelper nonceValue={nonce}/>
    </>
  );
}

export default NonceHelper;